export function stripNonASCIICharactersFromString(str: string) {
  //
  if (typeof str !== 'string') {
    console.warn(
      'stripNonASCIICharactersFromString :',
      str,
      'is not of type string'
    );
    //
    return '';
  }

  return str.replace(/[^\x00-\x7F]/g, '')?.trim();
}
